<template>
  <div>
    <slot name="label">
      <h2 class="mb-0">{{ $t('personalizedWalletCard.customize.emergency.label') }}</h2>
    </slot>
    <section>
      <!-- Emergency Contact 1 Name -->
      <div class="mt-3">
        <dp-input
          id="emergency-contact-primary-name-input"
          v-model.trim="contactName1"
          label="Emergency Contact 1 Name"
          name="emergency-contact-primary-name"
          type="text"
          class="emergency-text-field text-left notranslate"
          :validation-rules="{ before: { valid: true }, required: true, noEmojis: true, max: characterLimit }"
          :validation-state="validated ? 'valid' : null"
          translate="no"
          @input="$emit('updateEmergencyName', contactName1)"
        >
          <template #sub-text>
            <span v-show="contactName1.length <= characterLimit" class="text-dark">
              {{ characterCount(contactName1, characterLimit) }}
            </span>
          </template>
        </dp-input>
      </div>

      <!-- Emergency Contact 1 Phone -->
      <div class="mt-3">
        <dp-input
          id="emergency-contact-primary-phone-input"
          v-model.trim="contactPhone1"
          type="tel"
          label="Emergency Contact 1 Phone"
          name="emergency-contact-primary-phone"
          class="emergency-text-field text-left notranslate"
          inputmode="numeric"
          pattern="\([0-9]{3}\) [0-9]{3}-[0-9]{4}"
          :placeholder="phonePlaceholder"
          :value="formattedValue"
          :formatter="phoneNumberFormatter"
          :validation-rules="{ required: true, phoneNumber: true }"
          :validation-state="validated ? 'valid' : null"
          translate="no"
          @input="$emit('updateEmergencyPhone', contactPhone1)"
        />
      </div>

      <!-- Emergency Contact 2 Name -->
      <div class="mt-3">
        <dp-input
          id="emergency-contact-optional-name-input"
          v-model.trim="contactName2"
          label="Emergency Contact 2 Name"
          name="emergency-contact-optional-name"
          placeholder="Optional"
          type="text"
          class="emergency-text-field text-left notranslate"
          :validation-rules="{
            before: { valid: true },
            required_if: contactPhone2.length > 0,
            noEmojis: true,
            max: characterLimitOptional,
          }"
          :validation-state="validated ? 'valid' : null"
          translate="no"
          @input="$emit('updateEmergencyNameOptional', contactName2)"
        >
          <template #sub-text>
            <span v-show="contactName2.length <= characterLimitOptional" class="text-dark">
              {{ characterCount(contactName2, characterLimitOptional) }}
            </span>
          </template>
        </dp-input>
      </div>

      <!-- Emergency Contact 2 Phone -->
      <div class="mt-3">
        <dp-input
          id="emergency-contact-optional-phone-input"
          v-model.trim="contactPhone2"
          class="emergency-text-field text-left notranslate"
          label="Emergency Contact 2 Phone"
          inputmode="numeric"
          type="tel"
          name="emergency-contact-optional-phone"
          autocomplete="tel"
          pattern="\([0-9]{3}\) [0-9]{3}-[0-9]{4}"
          :placeholder="phonePlaceholder"
          :value="formattedValue"
          :formatter="phoneNumberFormatter"
          :validation-rules="{ before: { valid: true }, required_if: contactName2.length > 0, phoneNumber: true }"
          :validation-state="validated ? 'valid' : null"
          translate="no"
          @input="$emit('updateEmergencyPhoneOptional', contactPhone2)"
        >
        </dp-input>
      </div>
    </section>
  </div>
</template>

<script>
import DpInput from '@/components/library/Input';
export default {
  name: 'WalletCardEmergencyContact',
  components: { DpInput },
  props: {
    validated: {
      type: Boolean,
      default: false,
      required: true,
    },
    characterLimit: {
      type: [String, Number],
      default: 35,
      required: false,
    },
    characterLimitOptional: {
      type: [String, Number],
      default: 35,
      required: false,
    },
  },
  data() {
    return {
      contactName1: '',
      contactPhone1: '',
      contactName2: '',
      contactPhone2: '',
      phonePlaceholder: '(XXX) XXX-XXXX',
    };
  },
  computed: {
    formattedValue() {
      return this.phoneNumberFormatter(this.value);
    },
  },
  created() {},
  methods: {
    characterCount(character, limit) {
      const counter = limit - (character !== '' ? character.length : 0);
      return `
      ${counter}
      ${counter === 1 ? 'character' : 'characters'} remaining.`;
    },
    phoneNumberFormatter(phone) {
      if (phone) {
        let x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      }
    },
  },
};
</script>

<style lang="scss">
.emergency-text-field .form-group .form-control {
  height: 3.5rem;
  @media (min-width: 992px) {
    height: 4rem;
    font-size: 1.5rem;
  }
}
</style>
